import { createLightTheme } from "../../utils/createLightTheme.js";
import { brandWeb } from "../../global/brandColors.js";
export const webLightTheme = createLightTheme(brandWeb);
